/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Kind_Panda_LearnInputs */

const en_soft_kind_panda_learn = /** @type {(inputs: Soft_Kind_Panda_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL to a custom background image for the intro slide.`)
};

const de_soft_kind_panda_learn = /** @type {(inputs: Soft_Kind_Panda_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL zu einem benutzerdefinierten Hintergrundbild für die Intro-Folie.`)
};

/**
* | output |
* | --- |
* | "URL to a custom background image for the intro slide." |
*
* @param {Soft_Kind_Panda_LearnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_kind_panda_learn = /** @type {((inputs?: Soft_Kind_Panda_LearnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Kind_Panda_LearnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_kind_panda_learn(inputs)
	return de_soft_kind_panda_learn(inputs)
});